import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import {
  getFlagApplicableService,
  getFlagSearchList,
} from "../Actions/lookupAPI";
import MinusIcon from "../UIComponents/MinusIcon";
import { RadioGroup, Radio, FormControlLabel } from "@material-ui/core";
import AddIcon from "../UIComponents/AddIcon";
import axios from "axios";
import API from "../helpers/api";
import { postFlagAttachment } from "../Actions/CommonAPI";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import Autocomplete from "react-autocomplete";
import {
  getApplicableServiceTypeListWithInterval,
  getEquipmentNameListAndId,
} from "../Actions/helpersAPI";
import { validateFields } from "../Utils/utilities";
import swal from "sweetalert";
import { confirmAlert } from "react-confirm-alert";
import $ from "jquery";
import { t } from "i18next";
import { deleteAttachmentInBucket } from "../Actions/CommonAPI";
import i18n from "./DropdownLanguage/i18n";
import { OverlayTrigger, Popover } from "react-bootstrap";

let currentuser = JSON.parse(localStorage.getItem("currentUser"));

let searchData = {
  PortName: "",
  Country: "",
  PageNumber: 1,
  PageSize: 20,
};

var fileDatas = [];
class FlagEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      flaginfo: {
        flagId: 0,
        countryname: "",
        attachmentName: "",
        attachmentGuid: "",
        isDeleted: false,
        modifiedBy: currentuser.name,
        equipmentName: "",
        equipmentId: 0,
        capacity: "",
        category: "",
        equipmentType: "",
      },
      file: "",
      fileName: "",
      modalIsOpen: false,
      ApplicableServices: [],
      ApplicableServicesList: [],
      ServiceTypeList: [],
      selectedServiceYears: [],
      isFlagNew: true,
      AddServiceYear: [
        {
          flagApplicableServiceId: 0,
          flagId: 0,
          Id: 0,
          serviceTypeId: 0,
          equipmentId: 0,
          equipmentName: "",
          capacity: "",
          category: "",
          equipmentType: "",
          serviceType: "",
          servicetypelist: [],
          isShore: false,
          radioButton: "",
          isDeleted: false,
        },
      ],
      openEquipment: false,
    };
    this.UpdateFlag = this.UpdateFlag.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
    this.autocompleteRef = React.createRef();
  }

  async componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(getEquipmentNameListAndId());
    dispatch({ type: "SubBannerTitle", data: "Flag" });
    await axios.get(`${API.GetServiceTypeList}`).then((res) => {
      let list = [];
      let serviceTypeList = [];
      res.data.map((item, index) => {
        let listItem = item.serviceTypes.split(" ");
        let order = (listItem[0]);
        let id = item.id;
        list.push({
          id,
          order,
        });
      });

      let mainList = list.sort(function (a, b) {
        return a.order - b.order;
      });
      mainList.map((item, i) => {
        let serviceTypes = item.order + " yearly";
        item = item.id;
        serviceTypeList.push({
          item,
          serviceTypes,
        });
      });
      this.state.AddServiceYear[0].servicetypelist = serviceTypeList;
      this.setState({ ServiceTypeList: serviceTypeList });
    });
    dispatch(getFlagApplicableService(match.params.id));
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      flagDetail,
      dispatch,
      FlagAttachment,
      GetFlagApplicableService,
      applicableServiceType,
      FlagApplicableServices,
      match,
    } = nextProps;
    if (flagDetail && flagDetail !== "") {
      prevState.flaginfo.flagId = flagDetail.flagId;
      prevState.flaginfo.countryname = flagDetail.countryName;
      prevState.flaginfo.attachmentName = flagDetail.attachmentName;
      prevState.flaginfo.attachmentGuid = flagDetail.attachmentGuid;
      prevState.fileName = flagDetail.attachmentName;
      dispatch({ type: "flagDetails", data: "" });
    }
    if (FlagAttachment) {
      prevState.flaginfo.attachmentName = FlagAttachment.FileName;
      prevState.flaginfo.attachmentGuid = FlagAttachment.Guid;
      dispatch({ type: "postFlagAttachmentUploadSuccess", data: null });
    }
    if (prevState.file !== "") {
      dispatch(postFlagAttachment(prevState.file));
      prevState.file = "";
    }
    if (GetFlagApplicableService && GetFlagApplicableService !== "") {
      prevState.ApplicableServicesList =
        GetFlagApplicableService &&
        GetFlagApplicableService.map((u) => {
          let data = {
            flagApplicableServiceId: u.flagApplicableServiceId,
            flagId: u.flagId,
            serviceType: u.serviceType,
            serviceTypeId: u.serviceTypeId,
            equipmentId: u.equipmentId,
            isShore: u.isShore,
            equipmentName: u.equipmentName,
            capacity: u.capacity,
            category: u.category,
            equipmentType: u.equipmentType,
            radioButton: u.isShore ? "Shore" : "Ship",
            isDeleted: false,
          };
          return data;
        });
      dispatch({ type: "getFlagApplicableServiceSuccess", data: "" });
    }
    if (FlagApplicableServices) {
      prevState.ApplicableServicesList = FlagApplicableServices;
    }
    if (
      applicableServiceType &&
      applicableServiceType !== "" &&
      prevState.ApplicableServices &&
      prevState.ApplicableServices.length === 0
    ) {
      dispatch({ type: "getServiceTypeIntervalListFlagSuccess", data: "" });
      prevState.ApplicableServices =
        applicableServiceType.length &&
        applicableServiceType.map((d, i) => {
          let obj = {
            serviceType: d.serviceType,
            serviceTypeId: d.serviceTypeId,
            equipmentId: prevState.flaginfo.equipmentId,
            equipmentName: prevState.flaginfo.equipmentName,
            capacity: prevState.flaginfo.capacity,
            category: prevState.flaginfo.category,
            equipmentType: prevState.flaginfo.equipmentType,
            isShore: false,
            isDeleted: false,
            radioButton: "",
            flagApplicableServiceId: 0,
            flagId: parseInt(match.params.id),
          };
          return obj;
        });
    }
  }

  UpdateFlag() {
    const { dispatch, match, t } = this.props;
    let url = `${API.postFlag}`;
    axios
      .put(url, this.state.flaginfo)
      .then((response) => {
        if (response.data) {
          let url1 = `${API.flagApplicableServices}`;
          axios
            .put(url1, this.state.ApplicableServicesList)
            .then((res) => {
              let searchData = {
                Country: "",
                Mail: currentuser.email,
                PageNumber: 1,
                PageSize: 20,
              };

              if (fileDatas.length > 0) {
                this.props.dispatch(deleteAttachmentInBucket(fileDatas));
                fileDatas = [];
              }

              dispatch(getFlagSearchList(searchData));
              this.hideSidePanel();
              toast.success(`${t("CommonText.CommonUpdate")}`, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
              dispatch({
                type: "postFlagApplicableServiceSuccess",
                data: res.data,
              });
            })
            .catch((error) => {
              // swal("Error!", "Something went wrong. Please try again.", "warning");
              swal({
                title: t('SwalError.ErrorTitle'),
                text: t('CommonText.500ErrorMessage'),
                icon: 'warning',
                buttons: {
                  confirm: {
                    text: t('confirmAlertMessage.Ok')
                  }
                }
              });
              dispatch({
                type: "postFlagApplicableServiceFailure",
                error: "ERROR",
              });
            });
        }
        dispatch({
          type: "putFlagDetailSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        // swal("Error!", "Something went wrong. Please try again.", "warning");
        swal({
          title: t('SwalError.ErrorTitle'),
          text: t('CommonText.500ErrorMessage'),
          icon: 'warning',
          buttons: {
            confirm: {
              text: t('confirmAlertMessage.Ok')
            }
          }
        });
        dispatch({
          type: "putFlagDetailFailure",
          error: "ERROR",
        });
      });
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    if (nodeName === "fileName") {
      let filename = e.target.files[0].name;
      let regex = /^[0-9a-zA-Z\s\(\)\.\_\&\$\#\-\']+$/g;
      if (regex.test(filename)) {
        this.setState({
          file: e.target.files[0],
          fileName: e.target.files[0].name,
        });
      } else {
        // swal(
        //   "Error!",
        //   "Please upload the file without special characters.",
        //   "warning");
        swal({
          title: t('SwalError.ErrorTitle'),
          text: t('SwalError.UploadFile'),
          icon: 'warning',
          buttons: {
            confirm: {
              text: t('confirmAlertMessage.Ok')
            }
          }
        });
        return;
      }
    } else {
      this.state.flaginfo[nodeName] = e.target.value;
      this.setState({});
    }
  }
  handleRadioButtonChanges = (e, i) => {
    var lineitems = this.state.AddServiceYear;
    lineitems[i][e.target.name] = e.target.value;
    if (e.target.value === "Shore") {
      lineitems[i]["isShore"] = true;
    } else {
      lineitems[i]["isShore"] = false;
    }
    this.setState({ AddServiceYear: lineitems });
  };
  ClearInput() {
    //this.props.dispatch(deleteAttachmentInBucket(this.state.flaginfo.attachmentGuid,this.state.flaginfo.attachmentName));
    let obj = {
      filename: this.state.flaginfo.attachmentName,
      guid: this.state.flaginfo.attachmentGuid,
    }
    fileDatas.push(obj);
    this.state.flaginfo.attachmentName = "";
    this.state.flaginfo.attachmentGuid = "";
    this.setState({ file: "", fileName: "" });
  }


  renderedit(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{this.props.t("IntervelScreen.Edit")}</label>
        </Popover.Content>
      </Popover>
    );
  }

  renderdelete(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{this.props.t("CommonText.Delete")}</label>
        </Popover.Content>
      </Popover>
    );
  }

  deleteApplicableType = (item) => {
    const { t } = this.props;
    confirmAlert({
      message: `${t("confirmAlertMessage.DeleteMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            item.isDeleted = true;
            this.setState({});
          },
        },
        {
          label: `${t("confirmAlertMessage.No")}`,
          onClick: () => { },
        },
      ],
    });
  };

  renderFlagTitle(state, val) {
    return (
      state?.equipmentName?.toLowerCase().indexOf(val?.toLowerCase()) !== -1
    );
  }

  handleInputChanges(e, field) {
    this.state.flaginfo[field] = e.target.value;
    this.setState({});
  }

  handleSelectChange(value, field, item) {
    this.state.flaginfo[field] = value;
    this.state.flaginfo.equipmentId = item.equipmentId;
    this.state.flaginfo.category = item.category;
    this.state.flaginfo.capacity = item.capacity;
    this.state.flaginfo.equipmentType = item.equipmentType;
    if (this.state.ApplicableServicesList.length > 0) {
      let arrayYears = [];
      let result = [];
      let result1 = this.state.ServiceTypeList;
      let deletedArray = this.state.ApplicableServicesList;
      let index = deletedArray.map((item) => item.isDeleted).indexOf(true);

      if (deletedArray.length !== 0) {
        let result2 = deletedArray.filter(
          (i) => i.equipmentId === item.equipmentId
        );
        result2.map((j) => {
          arrayYears.push(j.serviceTypeId);
        });
      }
      else {
        let result2 = this.state.ApplicableServicesList.filter(
          (i) => i.equipmentId === item.equipmentId
        );
        result2.map((j) => {
          arrayYears.push(j.serviceTypeId);
        });
      }
      result = result1.filter(function (obj) {
        return arrayYears.indexOf(obj.item) === -1;
      });
      this.state.AddServiceYear[0].servicetypelist = result;
      this.setState({})
      /*  this.setState({ ServiceTypeList: result }); */
    }
    var lineitems = this.state.AddServiceYear;
    lineitems &&
      lineitems.map((a, i) => {
        a.flagId = this.state.flaginfo.flagId;
        a.equipmentId = item.equipmentId;
        a.equipmentName = value;
        a.capacity = item.capacity;
        a.category = item.category;
        a.equipmentType = item.equipmentType;
      });

    this.setState({ AddServiceYear: lineitems });
    this.autocompleteRef.current.blur();
    this.showFlagModal(0, true);
  }
  showFlagModal = (FlagId, isFlagNew, EquipId) => {
    var arrayStroage = this.state.ApplicableServicesList;
    var arrayLength = arrayStroage.length;
    if (FlagId > 0) {
      let response = this.state.ApplicableServicesList.filter(
        (item) => (item.Id === FlagId && item.equipmentId === EquipId) || (item.flagApplicableServiceId === FlagId && item.equipmentId === EquipId));
      let editModelDetails = response[0];
      var lineitems = this.state.AddServiceYear;
      lineitems &&
        lineitems.map((a, i) => {
          a.flagApplicableServiceId = editModelDetails.flagApplicableServiceId;
          a.flagId = this.state.flaginfo.flagId;
          a.Id = parseInt(editModelDetails.Id || editModelDetails.flagApplicableServiceId);
          a.equipmentId = editModelDetails.equipmentId;
          a.equipmentName = editModelDetails.equipmentName;
          a.capacity = editModelDetails.capacity;
          a.category = editModelDetails.category;
          a.equipmentType = editModelDetails.equipmentType;
          a.serviceTypeId = editModelDetails.serviceTypeId;
          a.serviceType = editModelDetails.serviceType;
          a.radioButton = editModelDetails.isShore ? "Shore" : "Ship";
          a.isDeleted = false;
        });
      let arrayYears = [];
      let result = [];
      let currentvalue = [];
      let result1 = this.state.ServiceTypeList;
      let deletedArray = this.state.ApplicableServicesList;
      currentvalue = result1.filter((i) => i.item === editModelDetails.serviceTypeId)
      let index = deletedArray.map((item) => item.isDeleted).indexOf(true);
      if (deletedArray.length !== 0) {
        let result2 = deletedArray.filter(
          (i) => i.equipmentId === editModelDetails.equipmentId
        );
        result2.map((j) => {
          arrayYears.push(j.serviceTypeId);
        });
      }
      else {
        let result2 = this.state.ApplicableServicesList.filter(
          (i) => i.equipmentId === editModelDetails.equipmentId
        );
        result2.map((j) => {
          arrayYears.push(j.serviceTypeId);
        });
      }
      result = result1.filter(function (obj) {
        return arrayYears.indexOf(obj.item) === -1;
      });
      let finalResult = [...currentvalue, ...result];
      let list = [];
      let newServiceTypeList = []
      finalResult.map((j, index) => {
        let listItem = j.serviceTypes.split(" ");
        let order = (listItem[0]);
        let id = j.item;
        list.push({
          id,
          order,
        });
      });

      let mainList = list.sort(function (a, b) {
        return a.order - b.order;
      });
      mainList.map((item, i) => {
        let serviceTypes = item.order + " yearly";
        item = item.id;
        newServiceTypeList.push({
          item,
          serviceTypes,
        });
      });
      this.state.AddServiceYear[0].servicetypelist = newServiceTypeList;
      this.setState(
        {
          modalIsOpen: !this.state.modalIsOpen,
          isFlagNew: isFlagNew,
          AddServiceYear: lineitems,
        },
        () => console.log(this.state.isFlagNew)
      );
    } else {
      var lineitems = this.state.AddServiceYear;
      lineitems &&
        lineitems.map((a, i) => {
          a.Id = arrayLength === 0 ? arrayLength + 1 : arrayLength > 0 ? arrayLength + 1 : 0;
        });
      this.setState(
        {
          isFlagNew: isFlagNew,
          AddServiceYear: lineitems,
          modalIsOpen: !this.state.modalIsOpen,
        },
        () => {
          console.log("addservice", this.state.AddServiceYear);
          console.log("model", this.state.modalIsOpen);
          this.ClearServiceYear();
        }
      );
    }
  };
  addApplicableType = () => {
    const { dispatch } = this.props;
    if (this.state.AddServiceYear.length > 0) {
      let isValidMiscCharge = this.miscChargeValidation();
      if (!isValidMiscCharge) {
        return;
      }
    }
    let temp = [];
    let GetFlag = this.state.ApplicableServicesList;
    if (this.state.AddServiceYear[0]?.flagApplicableServiceId !== 0) {
      temp = GetFlag.filter((j) => j.flagApplicableServiceId === this.state.AddServiceYear[0]?.Id);
    } else {
      temp = GetFlag.filter((j) => (j.Id === this.state.AddServiceYear[0]?.Id) && (j.equipmentId === this.state.AddServiceYear[0]?.equipmentId));
    }

    if (temp.length > 0) {
      GetFlag.forEach((ele, index) => {
        if (ele.flagApplicableServiceId !== 0) {
          if (ele.flagApplicableServiceId === this.state.AddServiceYear[0]?.Id) {
            GetFlag[index] = this.state.AddServiceYear[0];
          }
        } else {
          if ((ele.Id === this.state.AddServiceYear[0]?.Id) && (ele.equipmentId === this.state.AddServiceYear[0]?.equipmentId)) {
            GetFlag[index] = this.state.AddServiceYear[0];
          }
        }

      });
    } else {
      GetFlag.push(...this.state.AddServiceYear);
    }

    dispatch({
      type: "FlagApplicableServices",
      data: this.state.ApplicableServicesList,
    });
    console.log("Final Flag list", this.state.ApplicableServicesList)
    this.state.flaginfo.equipmentName = "";
    this.setState({ modalIsOpen: false }, () => {
      this.ClearServiceYear();
    });
  };
  miscChargeValidation() {
    const { t } = this.props;
    let validateField = [];
    let inValidComponent = [];
    let length = this.state.AddServiceYear.length;
    let miscCharges = this.state.AddServiceYear.filter(
      (item) => item.isDeleted === false
    );
    if (
      $("#chargeDescription0").val() === "" ||
      miscCharges[0].radioButton === ""
    ) {
      if ($("#chargeDescription0").val() === "") {
        $("#chargeDescription0ErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`);
      } else {
        $("#chargeDescription0ErrMsg").text("");
      }
      if (miscCharges[0].radioButton === "") {
        $("#isUnitPrice0ErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`);
      } else {
        $("#isUnitPrice0ErrMsg").text("");
      }
      return;
    } else {
      $("#chargeDescription0ErrMsg").text("");
      $("#isUnitPrice0ErrMsg").text("");
    }
    let indexFrom =
      $("#chargeDescription0").val() === "" && miscCharges[0].radioButton === ""
        ? 1
        : 0;
    miscCharges.forEach((row, index) => {
      if (index >= indexFrom) {
        validateField.push({ Id: `chargeDescription${index}`, Type: "text" });
        if (row.radioButton == "") {
          inValidComponent.push(`isUnitPrice${index}`);
          $("#isUnitPrice" + index + "ErrMsg").text(
            `${t("ErrorMessage.RequiredMsg")}`
          );
        } else {
          $("#isUnitPrice" + index + "ErrMsg").text("");
          var itemIndex = inValidComponent.indexOf(`isUnitPrice${index}`);
          if (itemIndex != -1) {
            inValidComponent.splice(itemIndex, 1);
          }
        }
      }
    });
    const validationResult = validateFields(validateField, true);
    validationResult.InValidFields.forEach((element, index) => {
      $("#" + element.Id + "ErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`);
    });
    validationResult.ValidFields.forEach((element, index) => {
      $("#" + element.Id + "ErrMsg").text("");
    });
    if (validationResult.IsValid === true && inValidComponent.length === 0) {
      return true;
    } else {
      return false;
    }
  }
  AddNewServiceYear() {
    let isValidMiscCharge = this.miscChargeValidation();
    if (!isValidMiscCharge) {
      return;
    }
    let result = [];
    let selectedValue = [];
    let result1 = this.state.ServiceTypeList;
    var arrayLength = 0;
    var arrayStroage = this.state.AddServiceYear;
    selectedValue = this.state.ApplicableServicesList.filter(item => item.equipmentId === arrayStroage[0].equipmentId)
    let result2 = this.state.selectedServiceYears;
    if (selectedValue.length !== 0) {
      selectedValue.map((i) => (
        result2.push(i.serviceTypeId)
      ))
    }
    console.log("selected", this.state.selectedServiceYears);
    result = result1.filter(function (obj) {
      return result2.indexOf(obj.item) === -1;
    });

    if (this.state.ApplicableServicesList.length > 0 && this.state.AddServiceYear.length > 0) {
      arrayLength = this.state.ApplicableServicesList.length + this.state.AddServiceYear.length;
    }
    else if (this.state.ApplicableServicesList.length > 0) {
      arrayLength = this.state.ApplicableServicesList.length;
    } else {
      arrayLength = this.state.AddServiceYear.length;
    }
    console.log("service years:", result);
    this.setState({
      AddServiceYear: [
        ...this.state.AddServiceYear,
        {
          flagApplicableServiceId: 0,
          flagId: this.state.flaginfo.flagId,
          Id: arrayLength + 1,
          serviceTypeId: 0,
          equipmentId: arrayStroage[0].equipmentId,
          equipmentName: arrayStroage[0].equipmentName,
          capacity: arrayStroage[0].capacity,
          category: arrayStroage[0].category,
          equipmentType: arrayStroage[0].equipmentType,
          servicetypelist: result,
          isShore: false,
          radioButton: "",
          isDeleted: false,
        },
      ],
    });
  }
  handleSelectYear = (e, i) => {
    let value = parseInt(e.target.value);
    let ServiceTypeList = this.state.ServiceTypeList.filter(
      (i) => i.item === value
    );
    let x = this.state.selectedServiceYears;
    x.push(value);
    this.setState({ selectedServiceYears: x });
    console.log("selected", this.state.selectedServiceYears);
    let AddServiceYear = this.state.AddServiceYear;
    AddServiceYear[i][e.target.name] = parseInt(e.target.value);
    AddServiceYear[i]["serviceType"] = ServiceTypeList[0].serviceTypes;
    this.setState({ AddServiceYear });
  };
  DeleteServiceYear(index) {
    const serviceCharges = [...this.state.AddServiceYear];
    serviceCharges.splice(index, 1);
    if (this.state.selectedServiceYears.length > 1) {
      const selectedServiceYear = [...this.state.selectedServiceYears];
      selectedServiceYear.splice(index, 1);
      this.state.selectedServiceYears = selectedServiceYear;
      this.setState({});
    }
    this.state.AddServiceYear = serviceCharges;
    this.setState({});
  }

  ClearServiceYear() {
    var arrayStroage = this.state.ApplicableServicesList;
    var arrayLength = arrayStroage.length;
    this.setState({
      AddServiceYear: [
        {
          flagApplicableServiceId: 0,
          flagId: this.state.flaginfo.flagId,
          Id: arrayLength === 0 ? arrayLength + 1 : arrayLength > 0 ? arrayLength + 1 : 0,
          serviceTypeId: 0,
          equipmentId: this.state.flaginfo.equipmentId,
          equipmentName: this.state.flaginfo.equipmentName,
          capacity: this.state.flaginfo.capacity,
          category: this.state.flaginfo.category,
          equipmentType: this.state.flaginfo.equipmentType,
          serviceType: "",
          servicetypelist: this.state.AddServiceYear[0].servicetypelist,
          isShore: false,
          radioButton: "",
          isDeleted: false,
        },
      ],
      selectedServiceYears: [],
    });
  }

  render() {
    const { t } = this.props;
    const { ApplicableServices } = this.state;
    return (
      <div className="pb-3">
        <Modal
          size="md"
          show={this.state.modalIsOpen}
          onHide={() => this.setState({ modalIsOpen: false })}
          aria-labelledby="example-modal-sizes-title-sm"
          backdrop="static"
          centered="true"
          animation="true"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-sm">
              {t("content.Servicetype")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.AddServiceYear.map((x, index) => {
              return (
                <>
                  <div className="row pt-2">
                    <div className="col-sm-5">
                      <select
                        className="form-control serviceyear"
                        name="serviceTypeId"
                        id={`chargeDescription${index}`}
                        value={x.serviceTypeId == 0 ? "" : x.serviceTypeId}
                        onChange={(e) => this.handleSelectYear(e, index, false)}
                      >
                        <option value="">{t("ClassScreen.SelectServiceYear")}</option>
                        {x &&
                          x?.servicetypelist?.map((name) => (
                            <option value={name.item}>
                              {name.serviceTypes}
                            </option>
                          ))}
                      </select>
                      <span
                        id={`chargeDescription${index}ErrMsg`}
                        className="spanErrMsg ml-2"
                      ></span>
                    </div>
                    <div className="col-sm-5" style={{ lineHeight: "0px" }}>
                      <RadioGroup
                        className="radio-value"
                        row
                        name="radioButton"
                        id={`isUnitPrice${index}`}
                        value={x.radioButton}
                        onChange={(e) =>
                          this.handleRadioButtonChanges(e, index)
                        }
                      >
                        <FormControlLabel
                          className="mt-0"
                          style={{ marginBottom: "11px" }}
                          value="Ship"
                          control={<Radio color="default" size="small" />}
                          label={t("Generateservicerequestcontent.Ship")}
                        />
                        <FormControlLabel
                          className="mt-0"
                          style={{ marginBottom: "11px" }}
                          value="Shore"
                          control={<Radio color="default" size="small" />}
                          label={t("Generateservicerequestcontent.Shore")}
                        />
                      </RadioGroup>
                      <span
                        id={`isUnitPrice${index}ErrMsg`}
                        className="spanErrMsg ml-2"
                      ></span>
                    </div>
                    <div
                      className={`col-sm-2 ${this.state.isFlagNew ? "" : "d-none"
                        }`}
                    >
                      <div
                        className={`mr-3 pl-1 ${index === 0 ? "d-none" : ""}`}
                      >
                        <div
                          className="flex"
                          onClick={() => this.DeleteServiceYear(index)}
                        >
                          <MinusIcon />
                        </div>
                      </div>
                      <div
                        className={`mr-3 pl-1 ${index === 0 ? "" : "d-none"}`}
                      >
                        <div
                          className="flex"
                          onClick={() => this.AddNewServiceYear()}
                        >
                          <AddIcon />
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}

            <div
              className="form-group search-btn-col mt-4"
              style={{ textAlign: "end" }}
            >
              <button
                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                type="submit"
                onClick={() => this.addApplicableType()}
              >
                {this.state.isFlagNew ? `${t("ComplianceandBudgetScreen.Submit")}` : `${t("EquipmentServiceTypes.Update")}`}
              </button>
              <button
                className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                type="button"
                onClick={() => this.showFlagModal(0, true)}
              >
                {" "}
                {t("ComplianceandBudgetScreen.Cancel")}{" "}
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {this.renderCardData()}
      </div>
    );
  }

  renderCardData() {
    const { EquipmentNameListAndId, FlagApplicableServices, Loading } =
      this.props;
    const { ApplicableServicesList } = this.state;
    const isArabic = i18n.language === 'arab'

    return (
      <div className="full-height">
        <div className="resource-list-auth-date row pt-3 ">
          <div className="col-lg-12">
            <div className="panel-box search-filter-box">
              <div
                className="card mt-2 MM-card-header"
                style={{ backgroundColor: "white" }}
              >
                <div
                  className="card-body"
                  style={{
                    padding: "0rem",
                    backgroundColor: "#1a3464",
                    color: "white",
                  }}>
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }} >
                    {t("FlagScreen.EditFlag")}
                  </h5>
                </div>
              </div>
              <div className="row search-filter-box">
                <div className="col-lg-4">
                  <label className="form-label">{t("FlagScreen.Title")}</label>
                  <br></br>
                  <input
                    className="form-control"
                    type="text"
                    name="countryname"
                    value={this.state.flaginfo.countryname}
                    placeholder={t("FlagScreen.Title")}
                    onChange={(e) => this.handleInputChange(e)}
                  ></input>
                </div>
                <div className="col-lg-4">
                  <label className="form-label">{t("FlagScreen.Attachment")}</label>
                  <br></br>
                  <div class="input-group ">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        {t("CommonText.BrowseFile")}
                        <input
                          type="file"
                          id="files"
                          name="fileName"
                          style={{ marginRight: 40 }}
                          onChange={(e) => this.handleInputChange(e)}
                          onClick={(event) => {
                            event.currentTarget.value = null;
                          }}
                        />
                      </span>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      placeholder={t("CommonText.Nofilechoosen")}
                      value={this.state.fileName}
                    />
                    {this.state.fileName ? (
                      <div
                        class="input-group-append"
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fa fa-times input-group-text padding-top-10px"
                          aria-hidden="true"
                          onClick={() =>
                            this.ClearInput()}
                        ></i>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>

              <div className="search-filter-box">
                <div
                  className="card mt-2 MM-card-header"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}
                  >
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      {t("ClassScreen.ApplicableServices")}
                    </h5>
                  </div>
                </div>

                <div className="row search-filter-box">
                  <div className="col-lg-4">
                    <div
                      className="autocomplete-wrappers"
                      style={{
                        zIndex:
                          this.state.openEquipment && !Loading ? 99999 : 0,
                      }}
                    >
                      <label className="form-label">{t("ShipEquipmentStatusScreen.EquipmentName")}</label>
                      <br></br>
                      <Autocomplete
                        contentEditable={true}
                        ref={this.autocompleteRef}
                        id="AutocompleteShipId"
                        open={!Loading ? this.state.openEquipment : false}
                        onMenuVisibilityChange={(isOpen) => {
                          this.state.openEquipment = isOpen;
                          this.setState({});
                        }}
                        value={this.state.flaginfo.equipmentName}
                        inputProps={{ placeholder: `${t("ShipEquipmentStatusScreen.EquipmentName")}` }}
                        items={EquipmentNameListAndId ?? []}
                        getItemValue={(item) => item.equipmentName}
                        shouldItemRender={this.renderFlagTitle.bind(this)}
                        renderMenu={(item) => (
                          <div className="dropdown">{item}</div>
                        )}
                        renderItem={(item, isHighlighted) => (
                          <div
                            className={`items ${isHighlighted ? "selected-items" : ""
                              }`}
                          >
                            {item.equipmentName}&nbsp; (
                            {item.category &&
                              (item.capacity || item.equipmentType)
                              ? item.category + ","
                              : item.category
                                ? item.category
                                : ""}
                            &nbsp;{" "}
                            {item.capacity &&
                              (item.category || item.equipmentType)
                              ? item.capacity + ","
                              : item.capacity
                                ? item.capacity
                                : ""}
                            &nbsp;{" "}
                            {item.equipmentType ? item.equipmentType : ""})
                          </div>
                        )}
                        onChange={(e) =>
                          this.handleInputChanges(e, "equipmentName")
                        }
                        onSelect={(value, item) =>
                          this.handleSelectChange(value, "equipmentName", item)
                        }
                      />
                    </div>
                  </div>
                </div>

                {ApplicableServicesList && ApplicableServicesList.length ? (
                  ApplicableServicesList.map((item, index) => {
                    if (!item.isDeleted) {
                      return (
                        <div
                          className="card m-3"
                          style={{
                            backgroundColor: "#f0f0f0",
                            overflow: "hidden",
                            position: "relative",
                          }}
                        >
                          <div className="p-3">
                            <div className="resource-list-auth-date">
                              <div className="row">
                                <div className="col-sm-9 col-md-10 col-9 m-auto">
                                  <div className="row">
                                    <div className="col-sm-7">
                                      <span>
                                        <strong>{t("ShipEquipmentStatusScreen.EquipmentName")} : </strong>
                                        {item.equipmentName}&nbsp; (
                                        {item.category &&
                                          (item.capacity || item.equipmentType)
                                          ? item.category + ","
                                          : item.category
                                            ? item.category
                                            : ""}
                                        &nbsp;{" "}
                                        {item.capacity &&
                                          (item.category || item.equipmentType)
                                          ? item.capacity + ","
                                          : item.capacity
                                            ? item.capacity
                                            : ""}
                                        &nbsp;{" "}
                                        {item.equipmentType
                                          ? item.equipmentType
                                          : ""}
                                        )
                                      </span>
                                    </div>
                                    <div className="col-sm-3">
                                      <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                                        <strong>{t("content.Servicetype")}  </strong>
                                        <strong>: </strong>

                                      </span>
                                      {item.serviceType}
                                    </div>
                                    <div className="col-sm-2">
                                      <span>
                                        <strong>{t("ComplianceandBudgetScreen.Type")} : </strong>
                                        {item.radioButton}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-sm-3 col-md-2 col-3 m-auto">
                                  <div className="text-right">
                                    <OverlayTrigger
                                      placement="bottom"
                                      delay={{ show: 250, hide: 400 }}
                                      overlay={this.renderedit()}
                                    >
                                      <i
                                        className="fa fa-edit fa-lg click m-1 px-1"
                                        onClick={() =>
                                          this.showFlagModal(
                                            item.Id ||
                                            item.flagApplicableServiceId,
                                            false, item.equipmentId
                                          )
                                        }
                                        aria-hidden="true"
                                        style={{
                                          color: " #1a3464",
                                          fontSize: "1.8rem",
                                        }}
                                      ></i>
                                    </OverlayTrigger>

                                    <OverlayTrigger
                                      placement="bottom"
                                      delay={{ show: 250, hide: 400 }}
                                      overlay={this.renderdelete()}
                                    >
                                      <i
                                        className="fa fa-trash click m-1 px-2"
                                        onClick={() =>
                                          this.deleteApplicableType(item)
                                        }
                                        aria-hidden="true"
                                        style={{
                                          color: " #1a3464",
                                          fontSize: "1.8rem",
                                        }}
                                      ></i>
                                    </OverlayTrigger>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })
                ) : (
                  <div
                    className="card m-3"
                    style={{ overflow: "hidden", position: "relative" }}
                  >
                    <div class="container">
                      <h6 className="resource-list-title no-item-card">
                        {t("CommonText.NoTasks")}
                      </h6>
                    </div>
                  </div>
                )}

                <div className="col-lg-12 search-filter-box">
                  <div className="search-btn-col" style={{ textAlign: "end" }}>
                    <button
                      className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                      type="submit"
                      onClick={() => this.UpdateFlag()}
                    >
                      {" "}
                      {t("EquipmentServiceTypes.Update")}{" "}
                    </button>

                    <button
                      className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                      type="button"
                      onClick={() => this.hideSidePanel()}
                    >
                      {" "}
                      {t("ComplianceandBudgetScreen.Cancel")}{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  hideSidePanel() {
    fileDatas = [];
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/LookUpFlag");
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    flagDetail: state.lookupReducer.flagDetail || null,
    Loading: state.PageLoaderReducer.loading,
    FlagAttachment: state.lookupReducer.FlagAttachment || null,
    GetFlagApplicableService:
      state.lookupReducer.GetFlagApplicableService || null,
    EquipmentNameListAndId:
      state.MasterScreenReducer.EquipmentNameListAndId || [],
    applicableServiceType:
      state.MasterScreenReducer.applicableServiceTypeInterval || null,
    FlagApplicableServices:
      state.MasterScreenReducer.FlagApplicableServices || null,
  };
}
export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(FlagEdit))
);